import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OmpButtonLabelMaxLength } from '../../order-management-portal.sections';

// Button-label text input with a live character counter; long labels break the portal's layout.
@Component({
  selector: 'omp-label-input',
  templateUrl: './omp-label-input.component.html',
  styleUrls: ['./omp-controls.scss'],
})
export class OmpLabelInputComponent {
  @Input() value: string;
  @Input() placeholder = '';
  @Input() maxLength: number = OmpButtonLabelMaxLength;
  @Output() valueChange = new EventEmitter<string>();

  get length(): number {
    let length = 0;
    if (this.value) {
      length = this.value.length;
    }
    return length;
  }

  get isOver(): boolean {
    return this.length > this.maxLength;
  }

  onValueChange(value: string) {
    this.value = value;
    this.valueChange.emit(value);
  }
}
